import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {MultiQuestion} from "./FormElement";
import FormElement from "./FormElement";
import CardFlip from "./CardFlip";

function AboutYou(props) {
    const {store, index} = props;

    const [submit, setSubmit] = useState(false);

    return (
        <div className={'AboutYou'}>
            <div id={'about-you'} className={'full'}>
                <div className={'card'}>
                    <h2>
                      Tell us a little bit about you…
                    </h2>
                    <p>
                      We are hoping to connect with a broad range of UC Berkeley students, faculty, staff, alumni, and community members through this website.  Could you share more about your background to help us better understand who we are reaching?
                    </p>
                    <CardFlip color={"#ffffff"} index={index} gem={false} store={store}
                              frontFace={<FormElement store={store} id={"AboutYou"} />}
                              backFace={<div className="message">
                                  <h2>Thank you</h2>
                                  <p>We hope you enjoyed the experience and learned a few new things about campus planning.</p>
                                  {/*<ul>*/}
                                  {/*  <li>*/}
                                  {/*    <a target={'_blank'} href="https://lrdp.berkeley.edu/">Long Range Development Plan</a>*/}
                                  {/*  </li>*/}
                                  {/*  <li>*/}
                                  {/*    <a target={'_blank'} href="https://strategicplan.berkeley.edu/">Strategic Plan</a>*/}
                                  {/*  </li>*/}
                                  {/*</ul>*/}
                              </div>} />


                </div>
            </div>
        </div>
    );
}

export default observer(AboutYou);
